import {useState} from "react";
import {useTranslation} from "../../Utils/UseTranslation";
import {Col} from "react-bootstrap";
import parse from "html-react-parser";
import {CiCircleInfo} from "react-icons/ci";
import NavigationButtons from "../../Components/Layout/Elements/NavigationButtons";
import ReaderEmpty from "../../Components/Reader/ReaderEmpty";
import ModalNote from "../../Components/Modal/ModalNote";
import ScreenContainerFirstTime from "../../Components/Reader/FirstTimeSetup/ScreenContainerFirstTime";

const SettingReminders = () => {

    const {t} = useTranslation()
    const [show, setShow] = useState()
    const [title, setTitle] = useState()
    const [text, setText] = useState()
    const [turnOnOff, setTurnOnOff] = useState(true)
    const [homeBtnBehavior, setHomeBtnBehavior] = useState()
    const [currentStep, setCurrentStep] = useState('homeScreen');
    const [fromSettingAlarms, setFromSettingAlarms] = useState(true)


    const settingReminder_1 = t('settingRemindersList_1', {
        settingsImageToken: '%SETTINGS_IMG%',
        settingsImageValue: '<img src="/icons/settings.png" />'
    });

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Col md={6} className={'text-start ps-4'}>

                <h2> {t("settingReminders")}</h2>
                {/*<p>{t('infoList4_text_2', { measureUnit: i18next.t('dynamicValues.unita_misura')})}</p>*/}

                <p className={''}>{t("settingRemindersText")}</p>

                <p className={'text-orange fw-bold mb-0 mt-2'}> {t("howTo")}</p>

                <hr className={'text-orange mb-1 mt-0 opacity-100 opacity-100 '}/>
                <p className={'mb-0 d-flex align-items-center justify-content-between'}>
                    <span>{settingReminder_1}</span>

                </p>
                <hr className={'text-orange my-1 opacity-100'}/>
                <p className={'mb-0 '}>
                    <span>{t("settingRemindersList_2")} </span>
                </p>
                <hr className={'text-orange my-1 opacity-100'}/>

                <p className={'mb-0 d-flex align-items-center justify-content-between'}>
                    <span>{t("settingRemindersList_3")}</span>
                    {/*

                    <span>
                        <CiCircleInfo className={'fs-3 text-end text-orange'} onClick={() => {
                            setShow(true)
                            setTitle(t('note'))
                            setText(t('settingRemindersNote'))
                        }}/>
                    </span>
*/}


                </p>
                <hr className={'text-orange my-1 opacity-100'}/>
                <p className={'mb-0 d-flex align-items-center justify-content-between'}>
                    <span>{t("settingRemindersList_4")}</span>

                </p>
                <hr className={'text-orange my-1 opacity-100'}/>
                <p className={'mb-0 d-flex align-items-center justify-content-between'}>
                    <span>{t("settingRemindersList_5")}</span>

                </p>
                <hr className={'text-orange my-1 opacity-100'}/>
                <p className={'mb-0  d-flex align-items-center justify-content-between'}>
                    <span>{t("settingRemindersList_6")}</span>

                </p>
                <hr className={'text-orange my-1 opacity-100'}/>
                <p className={'mb-0  d-flex align-items-center justify-content-between'}>
                    <span>{t("settingRemindersList_7")}</span>

                </p>
                <hr className={'text-orange my-1 opacity-100 mb-3'}/>

            </Col>
            <Col md={6} className={'align-self-center'}>
                <ReaderEmpty turnOnOff={turnOnOff} setTurnOnOff={setTurnOnOff} homeBtnBehavior={homeBtnBehavior}
                             setCurrentStep={setCurrentStep} currentStep={currentStep}>
                    {turnOnOff &&
                        <ScreenContainerFirstTime setHomeBtnBehavior={setHomeBtnBehavior} currentStep={currentStep}
                                                  setCurrentStep={setCurrentStep} fromSettingAlarms={fromSettingAlarms}
                                                 />}

                </ReaderEmpty>
                <p className={'fw-bold text-start mt-4 text-smaller'}>{t('disclaimer')}</p>

            </Col>
            <Col md={12} className={'text-start align-self-end'}>
                <NavigationButtons t={t} prevUrl={'/setting-alarms'} nextUrl={'/change-reader-settings'}/>
            </Col>
            <ModalNote show={show} handleClose={handleClose} text={text} title={title}></ModalNote>
        </>

    )
}

export default SettingReminders